import React, { useState, useEffect, useRef } from 'react';

const SOCKET_URL = "ws://localhost:18181";
const MY_STORE_ID = "SZG104000"; 
const MY_DEVICE_ID = "MASTER_CTRL_01"; 

function MiiraMasterController() {
  const [status, setStatus] = useState("Disconnected");
  const [cart, setCart] = useState([]);
  const [targetDeviceId, setTargetDeviceId] = useState(""); 
  const socket = useRef(null);

  useEffect(() => {
    socket.current = new WebSocket(SOCKET_URL);

    socket.current.onopen = () => {
      setStatus("Connected ✅");
      const initPayload = {
        type: "init",
        storeID: MY_STORE_ID,
        deviceID: MY_DEVICE_ID,
        deviceName: "React Master Panel"
      };
      socket.current.send(JSON.stringify(initPayload));
    };

    socket.current.onclose = () => setStatus("Disconnected ❌");

    return () => socket.current.close();
  }, []);

  const send = (payload) => {
    if (socket.current.readyState === WebSocket.OPEN) {
      const finalPayload = {
        ...payload,
        storeID: MY_STORE_ID,
        targetID: targetDeviceId || null
      };
      socket.current.send(JSON.stringify(finalPayload));
    }
  };

  // --- 1. CUSTOMER SCREEN ACTIONS ---
  const updateCart = (name, price) => {
    const newItems = [...cart, { name, price, qty: 1 }];
    const subtotal = newItems.reduce((acc, item) => acc + (item.price * item.qty), 0);
    const tax = subtotal * 0.05;
    const total = subtotal + tax;

    setCart(newItems);

    send({
      type: "customer_cart_update",
      data: {
        items: newItems,
        summary: {
          subtotal: subtotal.toFixed(2),
          tax: tax.toFixed(2),
          discount: "0.00",
          total: total.toFixed(2)
        }
      }
    });
  };

  const removeFromCart = (index) => {
    const newItems = cart.filter((_, i) => i !== index);
    const subtotal = newItems.reduce((acc, item) => acc + (item.price * item.qty), 0);
    const tax = subtotal * 0.05;
    const total = subtotal + tax;

    setCart(newItems);
    send({
      type: "customer_cart_update",
      data: {
        items: newItems,
        summary: {
          subtotal: subtotal.toFixed(2),
          tax: tax.toFixed(2),
          discount: "0.00",
          total: total.toFixed(2)
        }
      }
    });
  };

  const clearCart = () => {
    setCart([]);
    send({
      type: "customer_cart_update",
      data: {
        items: [],
        summary: { subtotal: "0.00", tax: "0.00", discount: "0.00", total: "0.00" }
      }
    });
  };

  // --- 2. KDS SCREEN ACTIONS ---
  // const sendNewOrder = () => {
  //   const id = Math.floor(1000 + Math.random() * 9000).toString();
  //   send({
  //     type: "kds_new_order",
  //     orderId: id,
  //     items: cart.map(i => i.name),
  //     timestamp: new Date().toISOString()
  //   });
  //   // Also trigger Token Screen creation automatically
  //   send({ type: "order_status", orderNo: id });
  //   setCart([]);
  // };

  // --- 3. TOKEN SCREEN ACTIONS (Updated for Stateful Server) ---
  
  // Logic: "Check/Create" tells server to add it if missing
  const checkOrCreateToken = (number) => {
    const val = number || document.getElementById('tokenNum').value;
    if (!val) return alert("Enter Token Number");
    send({
      type: "order_status",
      tokenNumber: val
    });
  };

  // Logic: "Update" moves status or completes it
  const updateTokenStatus = (number, newStatus) => {
    const val = number || document.getElementById('tokenNum').value;
    if (!val) return alert("Enter Token Number");

    send({
      type: "update_token_status",
            tokenNumber: val,
      newStatus: newStatus
    });
  };

  // End of Day Memory Release
  const clearAllTokens = () => {
      send({ type: "clear_store_tokens" });
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <div>
          <h1 style={{ margin: 0 }}>MiiRA Master Controller</h1>
          <p style={{ color: '#666' }}>Store ID: <strong>{MY_STORE_ID}</strong></p>
        </div>
        <div style={styles.badge}>{status}</div>
      </header>

      <div style={styles.targetSection}>
        <label>🎯 Target Device ID: </label>
        <input
          value={targetDeviceId}
          onChange={(e) => setTargetDeviceId(e.target.value)}
          placeholder="e.g. TKS_LOBBY_1"
          style={styles.targetInput}
        />
      </div>

      <div style={styles.grid}>
        <section style={styles.card}>
          <h2>🛒 Customer Display</h2>
          <div style={{ display: 'flex', gap: '5px', marginBottom: '10px' }}>
            <button onClick={() => updateCart("Noodles", 15.00)}>+ Noodles</button>
            <button onClick={() => updateCart("Masala Papad", 5.00)}>+ Papad</button>
          </div>
          <div style={styles.cartPreview}>
            {cart.map((item, i) => (
              <div key={i} style={{fontSize: '14px', marginBottom: '5px'}}>
                {item.name} - ${item.price.toFixed(2)} 
                <button onClick={() => removeFromCart(i)} style={styles.btnMini}>x</button>
              </div>
            ))}
          </div>
          <button onClick={clearCart} style={styles.btnDanger}>Reset Display</button>
        </section>

        <section style={styles.card}>
          <h2>📢 Lobby (Token)</h2>
          <input id="tokenNum" placeholder="Token # (e.g. 527-27)" style={styles.input} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => checkOrCreateToken()} style={styles.btnPrimary}>ADD / CHECK</button>
              <button onClick={() => updateTokenStatus(null, 'ready')} style={styles.btnSuccess}>READY</button>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button onClick={() => updateTokenStatus(null, 'preparing')} style={styles.btnWarning}>PREPARING</button>
              <button onClick={() => updateTokenStatus(null, 'completed')} style={styles.btnDanger}>PICKED UP</button>
            </div>
            <button onClick={clearAllTokens} style={{...styles.btnDanger, marginTop: '20px'}}>🧹 END OF DAY CLEAR</button>
          </div>
        </section>
      </div>
    </div>
  );
}

const styles = {
  container: { padding: '20px', backgroundColor: '#f4f7f6', minHeight: '100vh', fontFamily: 'sans-serif' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  badge: { padding: '8px 16px', borderRadius: '20px', background: '#fff', border: '1px solid #ddd' },
  targetSection: { background: '#fff', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #e0e0e0' },
  targetInput: { padding: '8px', marginLeft: '10px', width: '200px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '20px' },
  card: { background: '#fff', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
  cartPreview: { margin: '15px 0', padding: '10px', background: '#f9f9f9', border: '1px solid #eee', borderRadius: '8px', minHeight: '100px' },
  input: { width: '100%', padding: '12px', marginBottom: '10px', borderRadius: '6px', border: '1px solid #ddd' },
  btnPrimary: { background: '#1A237E', color: '#fff', flex: 1, padding: '12px', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  btnSuccess: { background: '#2e7d32', color: '#fff', flex: 1, padding: '12px', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  btnWarning: { background: '#ed6c02', color: '#fff', flex: 1, padding: '12px', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  btnDanger: { background: '#d32f2f', color: '#fff', padding: '12px', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  btnMini: { marginLeft: '10px', padding: '2px 6px', background: '#ffcdd2', border: 'none', borderRadius: '4px', cursor: 'pointer', color: '#c62828' }
};

export default MiiraMasterController;